module.exports = __webpack_public_path__ + "img/Swirls2880x2048.8e69c92a.webp";